<script>
const KEYS = ["1234567890-+", "qwertyuiop[]", "asdfghjkl;'", "zxcvbnm,./"],
  WHITE = "asdfghjkl;",
  BLACK = "wetyuop" + "zx"; // octave change
export default {
  functional: true,
  render(h) {
    const rows = KEYS.map(row => row.split("")).map(row => {
      const keyRow = row.map(i => {
        let val = "";
        if (WHITE.includes(i)) {
          val = "white";
        } else if (BLACK.includes(i)) {
          val = "black";
        }
        return h("div", { class: [val, "key"] }, [i]);
      });
      return h("div", { staticClass: "keyboard-row" }, [keyRow]);
    });

    return h("div", { staticClass: "keyboard" }, rows);
  }
};
</script>

<style lang="scss">
.keyboard {
  opacity: 0.9;
  display: inline-block;
  margin-top: 1em;
  width: 100%;
  &-row {
    display: flex;
    margin-bottom: 0.2em;
    text-transform: uppercase;
    font-weight: 500;
    @for $i from 0 through 4 {
      &:nth-child(#{$i}) {
        margin-left: $i * 4%;
      }
    }
  }

  .key {
    font-size: clamp(0.3em, 1.7vw, 1em);
    width: 7%;
    // height: 3em;
    border-radius: 0.5em;
    color: #777;
    border: 1px solid #777;
    margin-right: 0.2em;
    padding: 0.5em 0.75em;
    flex-shrink: 0;

    &:before {
      content: "";
      float: left;
      padding-top: 100%;
    }

    &::after {
      content: "";
      border-radius: inherit;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      box-shadow: 0 0 0.25em #444;
      box-shadow: 0 0 0.25em #fff;
      opacity: 0;
      transition: opacity 0.2s ease;
    }
    &:hover {
      &::after {
        opacity: 1;
      }
    }
    &.black {
      background: #000;
      color: #fff;
    }
    &.white {
      background: #fff;
      color: #000;
    }
  }
}
</style>
